// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { ResourceStatusArgs_abstract } from './../../abstract/SagaBase/Defines/ResourceStatusArgs_abstract';
export class ResourceStatusArgs extends ResourceStatusArgs_abstract {}
